@if (social()) {
  <app-social-pixi-canvas class="pixi-canvas-wrap" />
}
<warning-banner [display]="displayWarning()" />
@if (showLoader()) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}

<!-- Presentation Badging Login Page -->
@if (!this.isDataPassUser() && pageLoaded()) {
  <div
    class="guest-container guest-container-v1 flex justify-center items-center"
    [ngClass]="{
      'small-container': showGuestFormMobile,
      'login-container-v1': showSignUpCard(),
      'register-container': showRegister || mobileRegister,
    }"
  >
    @if (showGuestCard()) {
      <div
        class="guest-card guest-card-v1 flex justify-center items-center flex-column"
        [ngClass]="{ 'small-card': showGuestFormMobile }"
      >
        <div class="guest-header">
          @if (!warningMessage()?.description && displayEarlyAccess && earlyAccessMessage()?.message) {
            <div class="banner-container">
              <img alt="bell" class="m-r-14" src="../../../../assets/images/bell-icon.svg" />
              <span class="early-access-description">
                {{ earlyAccessMessage()?.message ?? '' }}
                @if (earlyAccessMessage()?.link?.url) {
                  <a [href]="earlyAccessMessage()?.link?.url" target="_blank">
                    {{ earlyAccessMessage()?.link?.text }}
                  </a>
                }
              </span>
            </div>
          }
          <h3 class="title">
            Welcome to <br />
            {{ connectedRoomSet() && connectedRoomSet()!.length > 1 ? scootaverse()?.name : roomsName }}
          </h3>
          @if (connectedRoomSet() && connectedRoomSet()!.length > 1) {
            <span class="subtitle">
              {{ roomsName }}
            </span>
          }
        </div>
        <div class="card-body">
          <div class="login-card">
            <new-sign-up-card
              [showSignIn]="true"
              [showRegister]="false"
              [showLoader]="showLoader()"
              [selectedIndex]="selectedIndex"
              (confirmAccount)="confirmAccount($event)"
              (forgotPassword)="forgotPassword($event)"
            ></new-sign-up-card>
          </div>
          <div class="guest-side-card">
            <div class="guest-form">
              <div class="guest-form-header">
                <h4>Continue as a guest</h4>
              </div>
              <div>
                <form [formGroup]="guestSignInForm" (submit)="guestSignIn()">
                  <div>
                    <mat-form-field
                      class="sign-input-v1"
                      appearance="outline"
                      [ngClass]="{ 'has-error': checkFirstNameExceedsLength() }"
                    >
                      <mat-label>First name</mat-label>
                      <input matInput placeholder="First name" formControlName="firstName" />
                    </mat-form-field>
                    @if (checkFirstNameExceedsLength()) {
                      <div class="error-block">{{ firstNameErrorMessage }}</div>
                    }
                  </div>
                  <div>
                    <mat-form-field
                      class="sign-input-v1"
                      appearance="outline"
                      [ngClass]="{ 'has-error': checkLastNameExceedsLength() }"
                    >
                      <mat-label>Last name</mat-label>
                      <input matInput placeholder="Last name" formControlName="lastName" />
                    </mat-form-field>
                    @if (checkLastNameExceedsLength()) {
                      <div class="error-block">{{ lastNameErrorMessage }}</div>
                    }
                  </div>
                  <div class="buttons-container flex flex-column justify-center items-center">
                    <button
                      type="submit"
                      id="guestButton"
                      mat-button
                      class="guest-button app-button sign-in"
                      [disabled]="!checkIfFormIsValid()"
                    >
                      Continue as Guest
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="create-account">
              <div>
                <h4>Create account?</h4>
                <a rel="noopener" class="benefits" href="https://scoot.app/benefits-of-registering/" target="_blank">
                  Benefits of registering
                </a>
              </div>
              <div>
                <button id="registerButton" mat-button class="small-button" (click)="handleRegisterButton()">
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
        @if (!showGuestFormMobile) {
          <div class="card-body mobile-card">
            <div class="initial-card">
              <div class="buttons-div">
                <button
                  id="showGuestButtonMobile"
                  mat-button
                  class="guest-button mobile-button app-button sign-in"
                  data-test-id="continue-guest-btn"
                  (click)="showGuestMobile()"
                >
                  Continue as a guest
                </button>
                <button
                  id="loginButtonMobile"
                  mat-button
                  class="login-button mobile-button app-button sign-in"
                  (click)="signUp()"
                >
                  Login
                </button>
              </div>
              <div class="or">Or</div>
              <div class="register"><span (click)="handleRegisterButton()">Register</span></div>
            </div>
          </div>
        }
        @if (showGuestFormMobile) {
          <div class="form-mobile">
            <form [formGroup]="guestSignInForm" (submit)="guestSignIn()">
              <div>
                <mat-form-field
                  class="sign-input-v1"
                  appearance="outline"
                  [ngClass]="{ 'has-error': checkFirstNameExceedsLength() }"
                >
                  <mat-label>First name</mat-label>
                  <input matInput placeholder="First name" formControlName="firstName" />
                </mat-form-field>
                @if (checkFirstNameExceedsLength()) {
                  <div class="error-block">{{ firstNameErrorMessage }}</div>
                }
              </div>
              <div>
                <mat-form-field
                  class="sign-input-v1"
                  appearance="outline"
                  [ngClass]="{ 'has-error': checkLastNameExceedsLength() }"
                >
                  <mat-label>Last name</mat-label>
                  <input matInput placeholder="Last name" formControlName="lastName" />
                </mat-form-field>
                @if (checkLastNameExceedsLength()) {
                  <div class="error-block">{{ lastNameErrorMessage }}</div>
                }
              </div>
              <div class="buttons-container flex flex-column justify-center items-center">
                <button
                  id="guestButtonMobile"
                  mat-button
                  type="submit"
                  class="guest-button mobile-button app-button sign-in"
                  [disabled]="!checkIfFormIsValid()"
                >
                  Continue
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    }
    @if (showSignUpCard()) {
      <new-sign-up-card
        [showSignIn]="true"
        [selectedIndex]="selectedIndex"
        (confirmAccount)="confirmAccount($event)"
        (forgotPassword)="forgotPassword($event)"
        [showRegister]="showRegister"
        (showMobileRegister)="showMobileRegister($event)"
      ></new-sign-up-card>
    }
  </div>
}
